import { StockCountService } from './service/stock-count.service';
import { Component, OnInit, Input } from '@angular/core';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { stockInterface } from 'src/app/util/interfaces/stock';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-stock-count',
	templateUrl: './stock-count.component.html',
	styleUrls: ['./stock-count.component.scss'],
})
export class StockCountComponent implements OnInit {
	constructor(
		private LabelsService: LabelsService,
		private StockCountService: StockCountService
	) {}

	labels: LabelsInterface = {
		lbl_cmdb_availbility: '',
		lbl_geral_informacoes_estoque_ci: '',
		lbl_geral_quantidade_emprestada: '',
	};

	lastStockForm: stockInterface[] = [];
	isLoadingLabels = true;
	isLoadingModal = true;

	@Input()
	idCmdb = '';
	qtdLoan: number | string;
	qtdAvailables: number | string;

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe(
			(labels) => {
				this.labels = labels;
				this.isLoadingLabels = false;
			},
			(errorRes) => {
				this.isLoadingLabels = false;
			}
		);
		this.StockCountService.getTotalQtds(this.idCmdb)
			.subscribe((total) => {
				this.qtdLoan = total.qtdLoan;
				this.qtdAvailables = total.qtdAvailables;
			})
			.add(() => {
				this.isLoadingModal = false;
			});
	}
}
